import { render, staticRenderFns } from "./AppSnackBar.vue?vue&type=template&id=753a873a&"
import script from "./AppSnackBar.vue?vue&type=script&lang=js&"
export * from "./AppSnackBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports